<template>
  <layout-navbar>
    <span class="text-gray-400 uppercase">
      <slot name="header" />
    </span>
  </layout-navbar>
  <div class="flex bg-gray-100 text-gray-800 justify-center text-center">
    <div class="w-full lg:max-w-screen-xl grid grid-cols-1 p-6 gap-6">
      <div class="bg-white justify-center text-center rounded shadow">
        <slot name="preview" />
      </div>
      <div class="grid grid-cols-3 gap-6">
        <div class="col-span-2 w-full bg-white justify-center text-center rounded shadow">
          <slot name="content" />
        </div>
        <div class="w-full bg-white justify-center text-center rounded shadow">
          <slot name="side-bar" />
        </div>
      </div>
    </div>
    <!--<slot name="preview"/>
    <div class='p-4'>
      <slot name='content'/>
    </div>-->
  </div>
</template>

<script>
import LayoutNavbar from '@/components/default-layout-components/LayoutNavbar'
export default {
  name: 'DetailsViewLayout',
  components: { LayoutNavbar },
}
</script>

<style scoped>

</style>
